module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"現在実施中のアンケートはありません":"現在実施中のアンケートはありません"},"en":{"現在実施中のアンケートはありません":"There are no surveys currently being conducted."}}')
  delete Component.options._Ctor
}
